import { render, staticRenderFns } from "./Note.vue?vue&type=template&id=1b7aac0b&scoped=true&"
import script from "./Note.vue?vue&type=script&lang=ts&"
export * from "./Note.vue?vue&type=script&lang=ts&"
import style0 from "./Note.vue?vue&type=style&index=0&id=1b7aac0b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b7aac0b",
  null
  
)

export default component.exports